import type { OverlayPlugin, OverlayContext, OverlayResult } from './types';

/**
 * Overlay registry. v1 product: awareness always on (no player toggles).
 * New overlays = new plugin file + register() call.
 */
const plugins = new Map<string, OverlayPlugin>();

export function registerOverlay(plugin: OverlayPlugin): void {
  // Idempotent — HMR / double boot must not throw
  plugins.set(plugin.id, plugin);
}

export function listOverlays(): OverlayPlugin[] {
  return [...plugins.values()];
}

/** Merge all registered plugins (always-on awareness). */
export function computeAllOverlays(ctx: OverlayContext): OverlayResult {
  const squares: NonNullable<OverlayResult['squares']> = [];
  const arrows: NonNullable<OverlayResult['arrows']> = [];
  const labels: NonNullable<OverlayResult['labels']> = [];

  for (const plugin of plugins.values()) {
    const r = plugin.compute(ctx);
    if (r.squares) squares.push(...r.squares);
    if (r.arrows) arrows.push(...r.arrows);
    if (r.labels) labels.push(...r.labels);
  }

  return { squares, arrows, labels };
}
